<div *ngIf="faqs">
    <nb-accordion>
        <nb-accordion-item *ngFor="let faq of faqs">
            <nb-accordion-item-header
                [ngClass]="{'active': current_faq && current_faq == faq}"
                (click)="current_faq = faq"
            >
                {{faq.domanda.it}}</nb-accordion-item-header>
            <nb-accordion-item-body>
                <div
                    *ngIf="parole_chiave && parole_chiave.length > 0"
                    class="row keyword-container"
                >
                    <div
                        class="keyword"
                        (click)="filterForParolaChiave(p)"
                        *ngFor="let p of current_parole_chiave"
                    >{{p.parolachiave.it}}</div>
                </div><br>
                <div *ngIf="faq.immagine">
                    <img [src]="BASE_PATH + '/immagini/informazioni/' + faq.id + '.jpg'">
                </div>
                <div [innerHTML]="faq.risposta.it"></div>
            </nb-accordion-item-body>
        </nb-accordion-item>
    </nb-accordion>
</div>
